<template>
    <div>
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance / General</span>
        </h4>

        <div class="trz-leave-settings-wrapper p-0 bg-transparent">  <!-- Abdullah added class here -->
            <!-- alpha fix- changed here . removed class bg-white from both  -->
        <b-tabs pills card content-class=" py-0" nav-class=" " nav-wrapper-class="trz-wizard-sidebar-settings d-none"> <!-- Abdullah added class here -->
            <b-tab active>
                <template v-slot:title>General</template>
                <div class="clearfix ">
                    <leave-attendance-general  ></leave-attendance-general>
                </div>
            </b-tab>
            <b-tab lazy>
                <template v-slot:title>Attendance</template>
                <div class="clearfix ">

                    <div class="row">
                        <div class="col-sm-6">
                            <b-form-group label="Click on the day to select/deselect weekly holidays">
                                <b-form-checkbox-group
                                    v-model="week_holidays"
                                    :options="options"
                                    buttons button-variant="outline-secondary" :disabled="disabled_by_acl">
                                </b-form-checkbox-group>
                            </b-form-group>
                            <!--
                                <b-form-group label="Select Company Week Start Day">
                                    <b-form-radio-group
                                            id="btn-radios-3"
                                            v-model="week_start_day"
                                            :options="options"
                                            buttons button-variant="outline-secondary"

                                            name="radio-btn-stacked">
                                    </b-form-radio-group>
                                </b-form-group>
                            -->
                        </div>


                    </div>

                    <div class="col-sm-12 row">
                        <div class="col-sm-6">
                            <b-form-group id="weekend_color_code-group" label='Weekend Color Code' label-for="weekend_color_code">
                                <b-form-input id="weekend_color_code" name="weekend_color_code" v-model="weekend_color_code" type="color" :disabled="disabled_by_acl"></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col-sm-6">
                            <b-form-group id="holiday_color_code-group" label='Holiday Color Code' label-for="holiday_color_code">
                                <b-form-input id="holiday_color_code" name="holiday_color_code" v-model="holiday_color_code" type="color" :disabled="disabled_by_acl"></b-form-input>
                            </b-form-group>

                        </div>
                    </div>

                    <div class="col-sm-12 d-none">
                        <b-form-group id="connect_to_payroll_calculation-group" label-for="connect_to_payroll_calculation">
                            <b-form-checkbox id="connect_to_payroll_calculation"  v-model="connect_to_payroll_calculation" name="connect_to_payroll_calculation" value="1" :disabled="disabled_by_acl">
                                Connect to Payroll Calculation?
                            </b-form-checkbox>
                        </b-form-group>
                    </div>

                    <div class="col-sm-12 row mt-4 ">


                        <div class="col-sm-6">

                            <b-form-group id="entry_time-group" label="Check In Time" label-for="entry_time">
                                <template>
                                <b-form-timepicker id="entry_time" name="entry_time" v-model="entry_time" now-button reset-button locale="en" :disabled="disabled_by_acl"></b-form-timepicker>
                                </template>
                            </b-form-group>

                            <b-form-group id="allow_grace_time_late_check_in-group" label-for="allow_grace_time_late_check_in">
                                <b-form-checkbox id="allow_grace_time_late_check_in"  v-model="allow_grace_time_late_check_in" name="allow_grace_time_late_check_in"  value="1" :disabled="disabled_by_acl">
                                    Grace Time (late check in) minutes
                                </b-form-checkbox>
                            </b-form-group>
                            <b-form-group id="grace_time_late_check_in-group" label="" label-for="grace_time_late_check_in" v-if="allow_grace_time_late_check_in">
                                <b-form-input id="grace_time_late_check_in" name="grace_time_late_check_in" type="text" v-model="grace_time_late_check_in" :disabled="disabled_by_acl"></b-form-input>
                            </b-form-group>

                             <div class="adjust-ealry-check-in-parent d-none">
                            <b-form-group id="adjust_salary_late_check_in-group" label-for="adjust_salary_late_check_in">
                                <b-form-checkbox id="adjust_salary_late_check_in"  v-model="adjust_salary_late_check_in" name="adjust_salary_late_check_in"  value="1" :disabled="disabled_by_acl">
                                    Adjust salary late check in
                                </b-form-checkbox>
                            </b-form-group>
                            <div class="col-sm-12 row" v-if="adjust_salary_late_check_in">
                                <div class="col-sm-6">
                                    <b-form-group id="days_salary_for_late_check_in-group" label="days salary for" label-for="days_salary_for_late_check_in" >
                                        <b-form-input id="days_salary_for_late_check_in" name="days_salary_for_late_check_in" type="text" v-model="days_salary_for_late_check_in" :disabled="disabled_by_acl"></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-6">
                                    <b-form-group id="days_late_check_in-group" label="days late check in" label-for="days_late_check_in" >
                                        <b-form-input id="days_late_check_in" name="days_late_check_in" type="text" v-model="days_late_check_in" :disabled="disabled_by_acl"></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>

                            <!--<b-form-group id="allow_overtime-group" label-for="allow_overtime">
                                <b-form-checkbox id="allow_overtime"  v-model="allow_overtime" name="allow_overtime"  value="1">
                                    Allow Overtime
                                </b-form-checkbox>
                            </b-form-group>
                            <div class="col-sm-12 row" v-if="allow_overtime">
                                <div class="col-sm-6">
                                    <b-form-group id="days_salary_for_overtime-group" label="days salary for" label-for="days_salary_for_overtime" >
                                        <b-form-input id="days_salary_for_overtime" name="days_salary_for_overtime" type="text" v-model="days_salary_for_overtime" ></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>-->



                        </div>

                        <div class="col-sm-6">
                            <b-form-group id="exit_time-group" label="Check Out Time" label-for="exit_time" >
                                <template>
                                <b-form-timepicker id="exit_time" name="exit_time" v-model="exit_time" now-button reset-button locale="en" :disabled="disabled_by_acl"></b-form-timepicker>
                                </template>
                            </b-form-group>

                            <b-form-group id="allow_grace_time_early_checkout-group" label-for="allow_grace_time_early_checkout">
                                <b-form-checkbox id="allow_grace_time_early_checkout"  v-model="allow_grace_time_early_checkout" name="allow_grace_time_early_checkout"  value="1" :disabled="disabled_by_acl">
                                    Grace Time (early checkout) minutes
                                </b-form-checkbox>
                            </b-form-group>
                            <b-form-group id="grace_time_early_checkout-group" label="" label-for="grace_time_early_checkout" v-if="allow_grace_time_early_checkout">
                                <b-form-input id="grace_time_early_checkout" name="grace_time_early_checkout" type="text" v-model="grace_time_early_checkout" :disabled="disabled_by_acl"></b-form-input>
                            </b-form-group>

                            <div class="adjust-ealry-checkout-parent d-none">
                            <b-form-group id="adjust_salary_early_checkout-group" label-for="adjust_salary_early_checkout">
                                <b-form-checkbox id="adjust_salary_early_checkout"  v-model="adjust_salary_early_checkout" name="adjust_salary_early_checkout"  value="1" :disabled="disabled_by_acl">
                                    Adjust salary early checkout
                                </b-form-checkbox>
                            </b-form-group>
                            <div class="col-sm-12 row" v-if="adjust_salary_early_checkout">
                                <div class="col-sm-6">
                                    <b-form-group id="days_salary_for_early_checkout-group" label="days salary for" label-for="days_salary_for_early_checkout" >
                                        <b-form-input id="days_salary_for_early_checkout" name="days_salary_for_early_checkout" type="text" v-model="days_salary_for_early_checkout" :disabled="disabled_by_acl"></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-6">
                                    <b-form-group id="days_early_checkout-group" label="days early checkout" label-for="days_early_checkout" >
                                        <b-form-input id="days_early_checkout" name="days_early_checkout" type="text" v-model="days_early_checkout" :disabled="disabled_by_acl"></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>

                        </div>
                    </div>



                    <div class="d-flex justify-content-center">
                        <b-form-group id="ess_punch-group" label-for="ess_punch">
                            <b-form-checkbox id="ess_punch"  v-model="ess_punch" name="ess_punch"  value="1">
                                Allow ESS Punch In/Out
                            </b-form-checkbox>
                        </b-form-group>

                    </div>

                    <!-- asfaq 8 july 2025 -->
                    <div class="d-flex justify-content-center">
                        <b-form-group id="attendance_flexibility-group" label-for="attendance_flexibility">
                            <b-form-checkbox id="attendance_flexibility" v-model="attendance_flexibility" name="attendance_flexibility" :value="1" :unchecked-value="0">
                            Enable Attendance Flexibility
                            </b-form-checkbox>
                        </b-form-group>
                        </div>

                            <div v-if="attendance_flexibility == 1" class="row">
                            <div class="col-sm-12 row mt-4 ">
                            <div class="col-sm-6">
                            <b-form-group id="office_start_time-group" label="Office Start Time" label-for="office_start_time">
                                <template>
                                <b-form-timepicker id="office_start_time" name="office_start_time" v-model="office_start_time" now-button reset-button locale="en" :disabled="disabled_by_acl"></b-form-timepicker>
                                </template>
                            </b-form-group>

                            </div>

                            <div class="col-sm-6">
                            <b-form-group id="office_end_time-group" label="Office End Time" label-for="office_end_time" >
                                <template>
                                <b-form-timepicker id="office_end_time" name="office_end_time" v-model="office_end_time" now-button reset-button locale="en" :disabled="disabled_by_acl"></b-form-timepicker>
                                </template>
                            </b-form-group>

                            </div>
                        </div>

                    </div>
                    <!-- asfaq 8 july 2025 -->


                    <div class="d-flex justify-content-center" v-if= "disabled_by_acl == false">
                        <b-button variant="success" @click="saveSettings()" class="">Update</b-button>
                    </div>


                </div>
            </b-tab>
            <b-tab lazy>
                <template v-slot:title>Leave Type</template>
                <div class="clearfix ">
                    <leave-types ></leave-types>
                </div>
            </b-tab>
            <b-tab lazy>
                <template v-slot:title>Leave Policy</template>
                <div class="clearfix ">
                    <leave-policies ></leave-policies>
                </div>
            </b-tab>

            <b-tab lazy >
                <template v-slot:title>Holidays</template>
                <div class="clearfix ">
                    <holidays-managed-by-system-user   v-if="supper_user == true"></holidays-managed-by-system-user>
                    <holidays  v-else></holidays>
                </div>
            </b-tab>

            <b-tab lazy>
                <template v-slot:title>
                    Attendance Devices
                </template>
                <div class="clearfix">
                    <div class="">
                        <attendance-devices  ></attendance-devices>
                    </div>
                </div>
            </b-tab>

            <b-tab lazy>
                <template v-slot:title>
                    Geo Locations
                </template>
                <div class="clearfix">
                    <div class="">
                        <all-geolocations  ></all-geolocations>
                    </div>
                </div>
            </b-tab>
            <!-- asfaq 8 july 2025 -->
            <b-tab lazy>
                <template v-slot:title>
                    Attendance Mobility
                </template>
                <div class="clearfix">
                    <div class="">
                        <l-a-mobility  ></l-a-mobility>
                    </div>
                </div>
            </b-tab>
            <!-- asfaq 8 july 2025 -->
            <b-tab lazy title="Approver Settings">
                <div class="clearfix">
                <div class="">
                    <approver-leave-approve-settings ></approver-leave-approve-settings>
                </div>
                </div>
            </b-tab>

            <!-- Ifti - 16-07-2025 - Start -->
            <!-- <b-tab lazy>
                <template v-slot:title>
                    Long Service Leave
                </template>
                <div class="clearfix">
                    <div class="">
                        <l-a-long-service-leave-settings></l-a-long-service-leave-settings>
                    </div>
                </div>
            </b-tab> -->
            <!-- Ifti - 16-07-2025 - End -->

        </b-tabs>
        </div>
    </div>





</template>
<script>
    export default{

        mounted() {

        },
        props: [],
        components: {

        },
        data(){

            return {
              company_id : 0 ,
                week_holidays : [6],
                //all_week_holidays : [6],
                week_start_day : 7,
                weekend_color_code : '#aaaaaa',
                holiday_color_code : '#aaaaaa',

                connect_to_payroll_calculation : false,

                entry_time : null,
                allow_grace_time_late_check_in : false,
                grace_time_late_check_in : 0,
                adjust_salary_late_check_in : false,
                days_salary_for_late_check_in : 0.1,
                days_late_check_in : 0,

                exit_time : null,
                allow_grace_time_early_checkout : false,
                grace_time_early_checkout : 0,
                adjust_salary_early_checkout : false,
                days_salary_for_early_checkout : 0.1,
                days_early_checkout : 0,

                allow_overtime : false,
                days_salary_for_overtime : 0,
                disabled_by_acl:false,
                acl:this.$acl,
                attendance_flexibility:0, // asfaq 8 july 2025
                office_start_time : null, // asfaq 8 july 2025
                office_end_time : null, // asfaq 8 july 2025


                options: [
                    { text: 'Friday', value: '5' },
                    { text: 'Saturday', value: '6' },
                    { text: 'Sunday', value: '0' },
                    { text: 'Monday', value: '1' },
                    { text: 'Tuesday', value: '2' },
                    { text: 'Wednesday', value: '3' },
                    { text: 'Thursday', value: '4' }
                ],

                supper_user : false,
                ess_punch : 0,

            }
        },
        methods:{

            checkSuperUser : function()
            {

                axios.get(this.$api_url+'/user-type-level' , {
                    params: {

                    }
                }).then(function(response){

                    //alert(response.data.user_type + ' >>> ' + response.data.user_level);
                    if((response.data.user_type == '1') && (response.data.user_level == '1'))
                        this.supper_user = true;

                }.bind(this));
            },

            getCompanyLeaveSettings:function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/leave/settings' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        //console.log( response.data);
                        this.company_id =  response.data.company_id;
                        //this.all_week_holidays = response.data.week_holidays;
                        this.week_holidays = response.data.week_holidays.split(',');
                        //this.week_start_day =  response.data.week_start_day;


                        this.weekend_color_code =  response.data.weekend_color_code;
                        this.holiday_color_code =  response.data.holiday_color_code;


                        this.connect_to_payroll_calculation =  response.data.connect_to_payroll_calculation;

                        this.entry_time =  response.data.entry_time;
                        this.allow_grace_time_late_check_in =  response.data.allow_grace_time_late_check_in;
                        this.grace_time_late_check_in =  response.data.grace_time_late_check_in;
                        this.adjust_salary_late_check_in =  response.data.adjust_salary_late_check_in;
                        this.days_salary_for_late_check_in =  response.data.days_salary_for_late_check_in;
                        this.days_late_check_in =  response.data.days_late_check_in;

                        this.exit_time =  response.data.exit_time;
                        this.allow_grace_time_early_checkout =  response.data.allow_grace_time_early_checkout;
                        this.grace_time_early_checkout =  response.data.grace_time_early_checkout;
                        this.adjust_salary_early_checkout =  response.data.adjust_salary_early_checkout;


                        this.allow_overtime =  response.data.allow_overtime;
                        this.days_salary_for_overtime =  response.data.days_salary_for_overtime;

                        this.ess_punch = response.data.ess_punch;

                        this.attendance_flexibility = response.data.flexible; // asfaq 8 july 2025
                        this.office_start_time = response.data.office_start_time; // asfaq 8 july 2025
                        this.office_end_time = response.data.office_end_time; // asfaq 8 july 2025
                    }

                }.bind(this));

            },
            saveSettings:function()
            {

                if(this.attendance_flexibility == 1){
                    if(this.office_start_time == null || this.office_end_time == null)
                    {
                        this.$bvToast.toast('Please select valid office start time and office end time.',
                        {
                            title: `Failed!`,
                            variant: 'danger',
                            solid: true
                        });

                        return;
                    }
                    if(this.office_start_time >= this.office_end_time)
                    {
                        this.$bvToast.toast('Please select valid office start time and office end time.',
                        {
                            title: `Failed!`,
                            variant: 'danger',
                            solid: true
                        });
                        return;
                    }
                }

                let currentObj = this;
                let formData = new FormData();
                formData.append('week_holidays', this.week_holidays);
                formData.append('weekend_color_code', this.weekend_color_code);
                formData.append('holiday_color_code', this.holiday_color_code);



                //formData.append('week_start_day', this.week_start_day);

                formData.append('connect_to_payroll_calculation', this.connect_to_payroll_calculation);

                formData.append('entry_time', this.entry_time);


                formData.append('allow_grace_time_late_check_in', this.allow_grace_time_late_check_in);
                formData.append('grace_time_late_check_in', this.grace_time_late_check_in);
                formData.append('adjust_salary_late_check_in', this.adjust_salary_late_check_in);
                formData.append('days_salary_for_late_check_in', this.days_salary_for_late_check_in);
                formData.append('days_late_check_in', this.days_late_check_in);

                formData.append('exit_time', this.exit_time);
                formData.append('allow_grace_time_early_checkout', this.allow_grace_time_early_checkout);
                formData.append('grace_time_early_checkout', this.grace_time_early_checkout);
                formData.append('adjust_salary_early_checkout', this.adjust_salary_early_checkout);
                formData.append('days_salary_for_early_checkout', this.days_salary_for_early_checkout);
                formData.append('days_early_checkout', this.days_early_checkout);

                formData.append('allow_overtime', this.allow_overtime);
                formData.append('days_salary_for_overtime', this.days_salary_for_overtime);

                formData.append('ess_punch', this.ess_punch);


                formData.append('flexible', this.attendance_flexibility); // asfaq 8 july 2025
                formData.append('office_start_time', this.office_start_time); // asfaq 8 july 2025
                formData.append('office_end_time', this.office_end_time); // asfaq 8 july 2025


                axios.post(this.$api_url+'/leave/settings', formData,)
                            .then(function (response)
                            {

                                this.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });
                                location.reload();

                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.serverError(error);
                            });

            },
        },
        created: function(){
            this.getCompanyLeaveSettings();

            this.checkSuperUser();

            if(this.acl['leave-attendances'] != 2)
            {
                this.disabled_by_acl = true;
            }


        },
        computed:
        {


        }
    }
</script>
<style >
    .trz_leave_settings .custom-select{width: auto !important;}
    .trz-wizard-sidebar-settings .nav li.nav-item{margin-bottom:10px;}
    .trz_list li{margin-top:5px;}
    .trz-leave-settings-wrapper .card-header.trz-wizard-sidebar-settings {
	border-bottom-color: unset !important;
}


.trz-leave-settings-wrapper .card-header.trz-wizard-sidebar-settings {
    padding: 0 0.6rem !important;
	margin-bottom: 0;
	background-color: unset;
	border-bottom: unset;
}
.trz-leave-settings-wrapper {
	padding: 1.25rem 1.25rem;
	background-color: rgba(0, 0, 0, 0.03);
}

.trz-leave-settings-wrapper .card-body {
	padding-bottom: 25px;
}
</style>
